export default __webpack_public_path__ + "static/media/emissive.44242b2a.basis";